import { supabase } from '../supabase';
import { getOpenAIInstance } from '../openai';

export async function generateInvoiceItems(jobDescription: string) {
  const openai = await getOpenAIInstance();

  const completion = await openai.chat.completions.create({
    messages: [
      {
        role: 'system',
        content:
          'Generate detailed line items for an invoice based on job description. Include materials, labor, and other relevant charges.',
      },
      {
        role: 'user',
        content: `Generate invoice line items for this job: ${jobDescription}`,
      },
    ],
    model: 'gpt-4-turbo-preview',
    response_format: { type: 'json_object' },
  });

  return JSON.parse(completion.choices[0].message.content);
}

export async function suggestInvoicePricing(items: any[], marketData: any) {
  const openai = await getOpenAIInstance();

  const completion = await openai.chat.completions.create({
    messages: [
      {
        role: 'system',
        content:
          'Suggest competitive pricing for invoice items based on market rates and provided data. Consider factors like location, complexity, and market conditions.',
      },
      {
        role: 'user',
        content: `Suggest pricing for these items with market context: ${JSON.stringify({ items, marketData })}`,
      },
    ],
    model: 'gpt-4-turbo-preview',
    response_format: { type: 'json_object' },
  });

  return JSON.parse(completion.choices[0].message.content);
}

export async function generatePaymentTerms(clientHistory: any, invoiceAmount: number) {
  const openai = await getOpenAIInstance();

  const completion = await openai.chat.completions.create({
    messages: [
      {
        role: 'system',
        content:
          'Suggest appropriate payment terms based on client payment history and invoice amount. Consider factors like client reliability and cash flow impact.',
      },
      {
        role: 'user',
        content: `Suggest payment terms for amount ${invoiceAmount} with client history: ${JSON.stringify(clientHistory)}`,
      },
    ],
    model: 'gpt-4-turbo-preview',
  });

  return completion.choices[0].message.content;
}
